import React, {useState, useEffect} from "react";
import { AppContext } from "../../contexts/AppContext";
import { getLabelFromId } from "../../Services/localStorage.tsx";


const GenderChange = () => {
  const { appState } = React.useContext(AppContext);
  const changedGender = appState?.requestPayload?.applicant?.genderId;
  const [genderLabel, setGenderLabel] = useState("");

   useEffect(() => {
      // Load passport data from localStorage if not already in state
  
      getLabelFromId("GenderReference", changedGender).then(
        (genderLabel) => {
          setGenderLabel(genderLabel);
        }
      );
    }, [changedGender]);

  return (
    <React.Fragment>
      <div className="step-container">
        <h2 className="step-title mb-2">Current gender details</h2>
        <div className="step-container-nospace">
          <div className="step-container-box">
            <p className="label">Gender</p>
            <p className="value">{genderLabel}</p>
          </div>
          
        </div>
      </div>
    </React.Fragment>
  );
};

export default GenderChange;
